import { Pick, PickItem } from 'services/picking';

export const getPickItemItemIds = (pick: Pick): number[] | null => {
  const pickIds = pick.pickItems.map((pickItem: PickItem) => pickItem.itemId);

  const noNullPickIds = pickIds.filter((value) => value !== null) as number[];
  //filter out duplicate ids
  return Array.from(new Set(noNullPickIds));
};
